import axios from "axios";
import configuration from "../../configuration/configuration";

export function generateGALinkerId(url) {

    return url.toString();
   
  }

  export function getSessionCookieAndSyfToken(){
    let nameEQ = "syfToken" + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return "MPP";
}

export function getSyfQuickScreenDecline(){
  let nameEQ = "syf_QS_Decline" + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return false;
}

export async function populateSyfTokenCookie(partnerId){
  let existingCookie = getSessionCookieAndSyfToken();
    if(existingCookie === "MPP" || existingCookie===undefined || existingCookie.indexOf(partnerId)<0){
        let cookieData = await setCookie(partnerId);
        return cookieData;
    }else{
        var expDate = new Date();
        expDate.setHours(expDate.getHours() + 2);
        var expires = "expires=" + expDate.toGMTString();
        let cookieContent = "syfToken" + "=" + existingCookie + ";" + expires + ";path=/;";
        document.cookie = cookieContent
        return existingCookie;
    }
}

const setCookie = async (partnerId) => {
    var expDate = new Date();
    expDate.setHours(expDate.getHours() + 2);
    var expires = "expires=" + expDate.toGMTString();

    var data = await axios.get(configuration[window._syfMpp_.SYF_MPP_ENV].widgeturl+"/syftoken?partnerId="+partnerId)
    .then((response) => response.data)
      .then((data) => {
        let cookieContent = "syfToken" + "=" + data["syf-token"] + ";" + expires + ";path=/;";
        document.cookie = cookieContent;
        return data["syf-token"];
      })

    return data;
}

export function getUpdatedFlow(orgFlow, postfix, stripeFlow){
  if((orgFlow === 'Checkout-MPP' || orgFlow === 'Checkout-Stripe-MPP' || orgFlow === 'MPPDirect' || orgFlow.includes('QSWidget')) && postfix === 'MPP') return orgFlow;
  if (stripeFlow === "Y" && postfix === "MPQ" &&
      (orgFlow === "Checkout-MPP" || orgFlow === "Checkout-Stripe-MPP" || orgFlow === "Checkout-Stripe-MPP-dBuy")) {
    return "Checkout-Stripe-MPP-MPQ";
  }
  return orgFlow + "-" + postfix;
}

export function getDeviceType() {
  const ua = navigator.userAgent;
  const platform = navigator.platform || navigator.userAgentData?.platform || "";
  
  // 1. Mobile Check
  // Includes iPhones and Android devices with the "Mobile" token
  if (/iPhone/i.test(ua) || (/Android/i.test(ua) && /Mobile/i.test(ua))) {
    return "Mobile";
  }

  // 2. Tablet Check
  // Includes Android Tablets (Android but no "Mobile" token)
  // And iPads (iPad string OR Mac string + Touch + Square Screen)
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
  
  const isMacHardware = /iPad|Macintosh/i.test(ua) || /MacIntel/i.test(platform);
  const hasTouch = navigator.maxTouchPoints > 1;
  const screenRatio = window.screen.height / window.screen.width;
  const isSquareish = screenRatio < 1.5 && screenRatio > 0.5;
  const isiPad = isMacHardware && hasTouch && isSquareish;

  if (isAndroidTablet || isiPad) {
    return "Tablet";
  }

  // 3. Desktop Check
  // Includes MacBooks, Windows, and Linux desktops
  return "Desktop";
};

export default {generateGALinkerId, populateSyfTokenCookie, getDeviceType}